import React from 'react';
import moment from 'moment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import QueryStringService from '../../services/queryStringService.js';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import PanelService from '../../services/panelService';

export default class PanelIDSExportButton extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.state = {
        };

        this.exportToExcel = this.exportToExcel.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    exportToExcel() {
        if (this.props.exportAllowed === 'No') {
            toast.info("Not possible to export IDS file for this product");
            console.log("Not possible to export IDS file for this product");
            return;
        }

        if (this.props.panels === undefined) {
            toast.error("An error occurred during export. Please contact support.");
            console.error("Panel list undefined");
            return;
        }

        if (this.props.useIDSExportFormat !== undefined && this.props.useIDSExportFormat && this.props.targetSoV === undefined) {
            toast.error("An error occurred during export. Please contact support.");
            console.error("targetSoV is undefined");
            return;
        }

        let panels = [];
        if (this.props.campaignType === 'posting') {
            let posted = this.props.panels.filter(p => p.status === 'Posted' && p.externalKey !== '');
            panels = posted.map((panel, i) => {
                return {
                    faceid: `${panel.externalKey}`
                };
            });
        }
        else if (this.props.useIDSExportFormat !== undefined && this.props.useIDSExportFormat) {
            let panelExport;
            if (this.props.considerSoVWhenExportingIDSPanels !== undefined && this.props.considerSoVWhenExportingIDSPanels) {
                const useNewSoVCalculation = moment(this.props.periodStart).format('YYYY-MM-DD') >= moment(this.props.newSOVCalculationFrom).format('YYYY-MM-DD');
                panelExport = PanelService.getIDSPanelsThatMatchesTargetSoV(this.props.targetSoV, this.props.SoVFaultTolerance, this.props.SoVNoOfDecimals, this.props.panels, useNewSoVCalculation);
            }
            else {
                panelExport = PanelService.getIDSPanels(this.props.panels);
            }
            panels = panelExport.map((panel, i) => {
                return {
                    faceid: `${panel.externalKey}`
                };
            });
        }
        else {
            panels = this.props.panels.map((panel, i) => {
                return {
                    Panel: `${panel.panelId}`
                };
            });
        }
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(panels);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        var ua = window.navigator.userAgent;
        if (ua.match(/Edge/)) {
            window.navigator.msSaveBlob(data,
                'PoP-IDS-' + `${this.props.campaignName}` + '-' + `${moment().format('YYYY-MM-DD HH:mm')}` + fileExtension);
        } else {
            FileSaver.saveAs(data, 'PoP-IDS-' + `${this.props.campaignName}` + '-' + `${moment().format('YYYY-MM-DD HH:mm')}` + fileExtension);
        }
    }

    render() {
        let colorClass = 'btn-play';
        if (this.props.campaignType === 'posting') {
            colorClass = 'btn-posting';
        }

        return (
            <div >
                <button disabled={!this.props.allowExport}
                    className={'btn ' + colorClass + ' hidden-print'}
                    style={this.props.style}
                    target='_blank'
                    onClick={() => { this.exportToExcel(this.props.panels) }}
                    >
                    {(this.props.label ? this.props.label : "Export IDS file")}
                </button>
            </div>
        );
    }
}